









import { Vue, Component } from 'vue-property-decorator'

@Component({})
export default class TipDialog extends Vue {
  hide() {
    this.$emit('on-hide')
  }
}
